import { statusMessages } from '@app/modules/logger/screens/status/components/options';
import { StatusBadge, theme } from '@mi-front/ui';
import SensorsIcon from '@mui/icons-material/Sensors';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

interface Props {
  readonly isOnline: boolean;
  readonly compact?: boolean;
}

/**
 * Status indicator: icon-only when compact (Sensors/SensorsOff), full badge otherwise.
 */
export function StatusIndicator(p: Props) {
  const { $t } = useIntl();
  const { isOnline, compact = false } = p;

  if (compact) {
    const Icon = isOnline ? SensorsIcon : SensorsOffIcon;
    return (
      <Box
        sx={{
          backgroundColor: isOnline ? theme.green : theme.pink,
          color: 'white',
          borderRadius: '50%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '1.5rem',
          height: '1.5rem',
        }}
        aria-label={isOnline ? $t(statusMessages.online) : $t(statusMessages.offline)}
      >
        <Icon fontSize="small" />
      </Box>
    );
  }

  return (
    <StatusBadge
      size="medium"
      style={{ minWidth: '7.5rem' }}
      status={isOnline}
      onText={$t(statusMessages.online)}
      offText={$t(statusMessages.offline)}
    />
  );
}
